<template>
  <div class="form-designer">
    <el-container>
      <!-- 左侧可选表单项列表:draggable -->
      <el-aside :width="leftWidth">
        <div class="fields-list">
          <div v-for="(field, index) in fields" :key="index">
            <!--  -->
            <div v-if="!field.disabled">
              <div class="field-title">{{ field.title }}</div>
              <draggable
                tag="ul"
                :list="field.list"
                :group="{ name: 'form', pull: 'clone', put: false }"
                ghost-class="ghost"
                :sort="false"
              >
                <li
                  class="field-label"
                  v-for="(item, index) in field.list"
                  :key="index"
                >
                  <a>
                    <i class="icon iconfont" :class="item.icon"></i>
                    <span>{{ item.title || item.label }}</span>
                  </a>
                </li>
              </draggable>
            </div>
            <!--  -->
            <div v-else>
              <div class="field-title">
                {{ field.title }}
                <span class="danger">（开发中）</span>
              </div>
              <ul>
                <li
                  class="field-label-disabled"
                  v-for="(item, index) in field.list"
                  :key="index"
                >
                  <a>
                    <i class="icon iconfont" :class="item.icon"></i>
                    <span>{{ item.title || item.label }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-aside>
      <!-- 中间主布局 -->
      <el-container class="widget-container" direction="vertical">
        <!-- 操作栏 -->
        <el-header class="widget-container-header">
          <div>
            <template v-if="undoRedo">
              <el-button
                type="text"
                size="medium"
                icon="el-icon-refresh-left"
                :disabled="historySteps.index == 0"
                @click="widgetForm = handleUndo()"
                >撤销</el-button
              >
              <el-button
                type="text"
                size="medium"
                icon="el-icon-refresh-right"
                :disabled="historySteps.index == historySteps.steps.length - 1"
                @click="widgetForm = handleRedo()"
                >重做</el-button
              >
            </template>
          </div>
          <div>
            <el-button
              type="text"
              size="medium"
              icon="el-icon-upload2"
              @click="importJsonVisible = true"
              >导入JSON</el-button
            >
            <el-button
              type="text"
              size="medium"
              icon="el-icon-download"
              @click="handleGenerateJson"
              >生成JSON</el-button
            >
            <el-button
              type="text"
              size="medium"
              icon="el-icon-view"
              @click="handlePreview"
              >预览</el-button
            >
            <el-button
              class="success"
              type="text"
              size="medium"
              icon="el-icon-folder-add"
              @click="showDialogSaveBox"
              >保存</el-button
            >
            <el-button
              class="danger"
              type="text"
              size="medium"
              icon="el-icon-delete"
              @click="handleClear"
              >清空</el-button
            >
            <el-button
              class="danger"
              type="text"
              size="medium"
              icon="el-icon-close"
              @click="handleClose"
              >关闭</el-button
            >
          </div>
        </el-header>
        <!-- <el-main
          :style="{
            background: widgetForm.column.length == 0 ? `url(${widgetEmpty}) no-repeat 50%` : '',
          }"
        > -->
        <avue-form :option="defaultFormOption_"></avue-form>
        <el-main
          :style="`background:url(${widgetEmpty}) no-repeat`"
        >
        <div :style="`background:url(${widgetEmpty})`"></div>
          <widget-form
            :class="{ mobile: isMobileTag }"
            :style="{ backgroundImage: 'url(' + bgImg + ')' }"
            ref="widgetForm"
            :data="widgetForm"
            :select.sync="widgetFormSelect"
             :fieldslist="tableFields_"
             @delete="handleDelete"
            @change="handleHistoryChange(widgetForm)"
          ></widget-form>
        </el-main>
      </el-container>
      <!-- 中间展示end -->
      <!-- 右侧配置 -->
      <el-aside class="widget-config-container" :width="asideRightWidth">
        <el-tabs v-model="configTab" stretch>
          <el-tab-pane
            label="字段属性"
            name="widget"
            style="padding: 0 10px"
            v-if="!widgetFormSelect.noEdit"
          >
            <!-- 专属配置页面  -->
            <widget-config 
            :totaloption="widgetForm"
            :data="widgetFormSelect" 
            :fieldslist="tableFields" 
            :fieldId="fieldIndex"
            @index="getFieldsListIndex"
            :selectFieldList="selectFieldList"
            @fieldsSelectChange="fieldsSelectChange"
            ></widget-config>
          </el-tab-pane>
          <el-tab-pane
            label="表单属性"
            name="form"
            lazy
            style="padding: 0 10px"
            v-if="!widgetFormSelect.noEdit"
          >
            <!-- 通用配置页面 -->
            <form-config :data="widgetForm" :fields="tableFields"></form-config>
          </el-tab-pane>
        </el-tabs>
      </el-aside>
      <!-- 抽屉 : 导入JSON -->
      <el-drawer
        title="导入JSON"
        :visible.sync="importJsonVisible"
        size="50%"
        append-to-body
        destroy-on-close
      >
        <v-json-editor
          v-model="importJson"
          :options="{ mode: 'code' }"
          height="82vh"
        ></v-json-editor>
        <div class="drawer-foot">
          <el-button
            size="medium"
            type="primary"
            @click="handleImportJsonSubmit"
            >确定</el-button
          >
          <el-button
            size="medium"
            type="danger"
            @click="importJsonVisible = false"
            >取消</el-button
          >
        </div>
      </el-drawer>
      <!-- A:抽屉 : 生成JSON -->
      <el-drawer
        title="生成JSON"
        :visible.sync="generateJsonVisible"
        size="50%"
        append-to-body
        destroy-on-close
      >
        <v-json-editor
          v-model="widgetFormPreview"
          :options="{ mode: 'code' }"
          height="82vh"
        ></v-json-editor>
        <div class="drawer-foot">
          <!--  A:底部按钮 -->
          <el-button size="medium" type="primary" @click="handleGenerate"
            >生成</el-button
          >
          <el-popover
            placement="top"
            trigger="hover"
            popper-class="popper-bo"
            width="250px"
          >
            <el-button
              size="medium"
              type="primary"
              slot="reference"
              @click="handleCopy"
              style="margin-left: 10px"
              >复制</el-button
            >
            <!--  A:复制hover -->
            <div>
              <el-form label-width="180px" label-position="left">
                <el-alert :closable="false">
                  在没有开启美化的情况下，当前编辑器内可见的文本，就是复制得到的内容。
                  <br />如有需要，您可以开启美化，然后选取适合自己的美化配置。
                  <a
                    href="https://www.npmjs.com/package/csvjson-json_beautifier"
                    target="_blank"
                    >参考资料</a
                  >
                </el-alert>
                <el-form-item label="是否开启美化">
                  <el-switch v-model="beautifierOptions.enabled" />
                </el-form-item>
                <el-form-item label="缩进长度-空格数量">
                  <el-slider
                    v-model="beautifierOptions.space"
                    show-stops
                    :marks="{ 1: '1', 2: '2', 3: '3', 4: '4' }"
                    :min="1"
                    :max="4"
                    :step="1"
                  ></el-slider>
                </el-form-item>
                <el-form-item label="引号类型">
                  <el-switch
                    v-model="beautifierOptions.quoteType"
                    active-value="single"
                    inactive-value="double"
                    active-text="单引号"
                    inactive-text="双引号"
                  ></el-switch>
                </el-form-item>
                <el-form-item label="移除key的引号">
                  <el-switch
                    v-model="beautifierOptions.dropQuotesOnKeys"
                  ></el-switch>
                </el-form-item>
                <el-form-item label="移除数字字符串的引号">
                  <el-switch
                    v-model="beautifierOptions.dropQuotesOnNumbers"
                  ></el-switch>
                </el-form-item>
              </el-form>
            </div>
          </el-popover>
        </div>
      </el-drawer>
      <!-- 预览 -->
      <el-drawer
        title="预览"
        :visible.sync="previewVisible"
        size="60%"
        append-to-body
        :before-close="handleBeforeClose"
      >
        <!-- 预览:avue-form -->
        <avue-form
          v-if="previewVisible"
          ref="form"
          class="preview-form"
          :class="{ mobile: isMobileTag }"
          :style="{ backgroundImage: 'url(' + bgImg + ')' }"
          :option="widgetFormPreview_"
          v-model="widgetModels"
          @submit="handlePreviewSubmit"
        ></avue-form>
        <div class="drawer-foot">
          <el-button size="medium" type="primary" @click="handlePreviewSubmit"
            >确定</el-button
          >
          <el-button size="medium" type="danger" @click="handleBeforeClose"
            >取消</el-button
          >
        </div>
      </el-drawer>
    </el-container>
    <!-- 保存弹窗 -->
    <el-dialog title="保存" :visible.sync="dialogFormVisible" append-to-body>
      <el-form :model="formInfo">
        <el-form-item label="表单名">
          <el-input v-model="formInfo.formName" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="表单编号">
          <el-input v-model="formInfo.formCode" maxlength="10"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 保存弹窗end -->
  </div>
</template>

<script>
import { saveForm, updateForm, getTableFieldsDataList, saveBindForm} from "@/api/form"; //api
import fields from "./fieldsConfig.js"; //data
import { stringify } from "./utils"; //util
import beautifier from "./utils/json-beautifier"; //util
import widgetEmpty from "./assets/widget-empty.png"; //imgage
import history from "./mixins/history"; //mixin

import Draggable from "vuedraggable"; //component
import VJsonEditor from "v-jsoneditor"; //component
import WidgetForm from "./WidgetForm"; //component
import FormConfig from "./FormConfig"; //component
import WidgetConfig from "./WidgetConfig"; //component

export default {
  name: "FormDesign",
  components: { Draggable, VJsonEditor, WidgetForm, FormConfig, WidgetConfig },
  mixins: [history],
  props: {
    tableFieldsList:{
      type: Array,
      default:()=>{
        return []
      }
    },
    options: {
      type: Object,
      default: () => {
        return {
          column: [],
        };
      },
    },
    optionsdefault: {
      type: Object,
      default: () => {
        return {};
      },
    },
    storage: {
      type: Boolean,
      default: false,
    },
    asideLeftWidth: {
      type: [String, Number],
      default: "270px",
    },
    asideRightWidth: {
      type: [String, Number],
      default: "380px",
    },
    undoRedo: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    beautifierOptions: {
      handler(val) {
        if (this.storage) {
          localStorage.setItem(
            "avue-form-beautifier-options",
            JSON.stringify(val)
          );
        }
      },
      deep: true,
    },
    options: {
      handler(val) {
        this.transAvueOptionsToFormDesigner(val).then((res) => {
          console.log("optionHandler======>res=====>",res);
          if(JSON.stringify(res)==='[]'){
            
            this.widgetForm.column = res;
          }else{

            this.widgetForm = { ...this.widgetForm, ...res };
          }
          // this.widgetForm.column = res;
          console.log('options:====>',this.widgetForm);
        });
      },
      deep: true,
    },
    tableFieldsList:{
      
      handler(val) {
        console.log("tableFieldsList:====>",val);
        this.tablefields = val;
      },
      deep: true,
    },
    tablefields:{
      
      handler(val) {
        console.log("tableFieldsList:====>",val);
        this.tablefields_ = val;
      },
      deep: true,
    },
    optionsdefault: {
      handler(val) {
        console.log("optionsdefault====>", val);
        setTimeout(() => {
          this.$set(this.defaultFormOption, "column", val.column);
          this.defaultFormOption["submitBtn"] = false;
          this.defaultFormOption["emptyBtn"] = false;
          console.log(this.defaultFormOption);
          this.defaultFormOption_ = this.deepClone(this.defaultFormOption);
          let list = [];
          this.defaultFormOption_.column.forEach((e)=>{
            e['disabled'] = true;
            list.push(e);
          });
          this.defaultFormOption_.column = list;

        });
      },
      deep: true,
    },
  },
  computed: {
    leftWidth() {
      if (typeof this.asideLeftWidth == "string") {
        return this.asideLeftWidth;
      } else {
        return `${this.asideLeftWidth}px`;
      }
    },
    rightWidth() {
      if (typeof this.asideRightWidth == "string") {
        return this.asideRightWidth;
      } else {
        return `${this.asideRightWidth}px`;
      }
    },
  },
  data() {
    return {
      selectFieldList:[],
      fieldIndex:'',
      tableFields_:{},
      tableFields:{},
      bgImg: "",
      radioLayout: "PC端",
      isMobileTag: false,
      formInfo: {
        formCode: "",
        formName: "",
      },
      dialogFormVisible: false,
      widgetEmpty,
      fields,
      widgetForm: {
        column: [],
        labelPosition: "right",
        labelSuffix: "：",
        labelWidth: 90,
        gutter: 0,
        menuBtn: true,
        submitBtn: true,
        submitText: "提交",
        emptyBtn: true,
        emptyText: "清空",
        menuPosition: "center",
        bindField:''
      },
      defaultFormOption:{submitBtn:false,emptyBtn:false},
      defaultFormOption_:{},
      widgetFormPreview: {},
      widgetFormPreview_:{},
      configTab: "widget",
      widgetFormSelect: {},
      previewVisible: false,
      generateJsonVisible: false,
      importJsonVisible: false,
      importJson: {},
      widgetModels: {},
      configOption: {},
      beautifierOptions: {
        enabled: false,
        space: 2,
        quoteType: "single",
        dropQuotesOnKeys: true,
        dropQuotesOnNumbers: false,
      },
      pageUrl_:'',
      history: {
        index: 0, // 当前下标
        maxStep: 20, // 最大记录步数
        steps: [], // 历史步数
      },
    };
  },
  created() {
    console.log("this.widgetfor==>", this.widgetForm);
    this.pageUrl_ = this.$route.query.pageUrl;
  },
  updated() {
    console.log("this.widgetform update==>", this.widgetForm);
    this.pageUrl_ = this.$route.query.pageUrl;
  },
  mounted() {
    console.log("this.widgit==>", this.widgetEmpty);
    this.handleLoadStorage();
    this.loadBeautifierOptions();
    this.handleLoadCss();
    this.handleGetTableFieldData();
    this.pageUrl_ = this.$route.query.pageUrl;
  },
  methods: {
    handleDelete(val){
      this.fieldIndex = val;
      console.log(val);
    },
    fieldsSelectChange(val){
      this.tableFields_ = val;
      console.log(this.tableFields_);
    },
    getFieldsListIndex(val){
      console.log(val);
      // this.fieldIndex = val;
      // console.log(this.fieldIndex);
    },
    handleGetTableFieldData(){
      let type = this.$route.query.type;
      let deptId = this.$route.query.deptId;
      let tableId = this.$route.query.tableid;
      let projectId = this.$route.query.projectId;
      getTableFieldsDataList(type,this.pageUrl_,deptId,tableId,projectId).then((res)=>{
        console.log(res.data.data.fields);
        this.tableFields = res.data.data.fields;
      })
    },

    handleRadioChange() {
      console.log(this.radioLayout);
      if (this.radioLayout === "PC端") {
        this.bgImg = "";
        this.isMobileTag = false;
      } else {
        this.isMobileTag = true;
        // this.bgImg = mobileImage;
      }
    },
    isMobile() {
      if (this.isMobile) {
        return "widget-container mobile";
      } else {
        return "widget-container";
      }
    },
    // 组件初始化时加载本地存储中的options(需开启storage),若不存在则读取用户配置的options
    async handleLoadStorage() {
      this.widgetForm = this.initHistory({
        index: 0,
        maxStep: 20,
        steps: [
          await this.transAvueOptionsToFormDesigner({
            ...this.widgetForm,
            ...this.options,
          }),
        ],
        storage: this.storage,
      });

      if (this.undoRedo) {
        window.addEventListener(
          "keydown",
          (evt) => {
            // 监听 cmd + z / ctrl + z 撤销
            if (
              (evt.metaKey && !evt.shiftKey && evt.keyCode == 90) ||
              (evt.ctrlKey && !evt.shiftKey && evt.keyCode == 90)
            ) {
              this.widgetForm = this.handleUndo();
            }

            // 监听 cmd + shift + z / ctrl + shift + z / ctrl + y 重做
            if (
              (evt.metaKey && evt.shiftKey && evt.keyCode == 90) ||
              (evt.ctrlKey && evt.shiftKey && evt.keyCode == 90) ||
              (evt.ctrlKey && evt.keyCode == 89)
            ) {
              this.widgetForm = this.handleRedo();
            }
          },
          false
        );
      }
    },
    // 获取JSON格式化属性
    loadBeautifierOptions() {
      const bo = localStorage.getItem("avue-form-beautifier-options");
      if (bo) this.beautifierOptions = JSON.parse(bo);
    },
    handleLoadCss() {
      const url = "https://at.alicdn.com/t/font_1254447_x280zepmf6.css";
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = url;
      window.document.head.appendChild(link);
    },
    // Avue文档链接
    handleAvueDoc() {
      window.open("https://avuejs.com/doc/form/form-doc", "_blank");
    },
    // 预览 - 弹窗
    handlePreview() {
      console.log("this.widgetModels==>", this.widgetModels);
      console.log("this.widgetForm===>", this.widgetForm);
      if (!this.widgetForm.column || this.widgetForm.column.length == 0)
        this.$message.error("没有需要展示的内容");
      else {
        this.transformToAvueOptions(this.widgetForm).then((data) => {
          this.widgetFormPreview = data;
          console.log('hhhhhhhhhh',
            JSON.stringify(this.widgetFormPreview) ==
              JSON.stringify(this.widgetForm)
          );
          this.widgetFormPreview_ = this.deepClone(this.widgetFormPreview);
          console.log("this.widgetFormPreview==========>",this.widgetFormPreview);
          // this.defaultFormOption.column.forEach((ele,index)=>{
          //   this.widgetFormPreview_.column.push(ele);
          // });
          this.widgetFormPreview_.column = this.defaultFormOption.column.concat(this.widgetFormPreview_.column);
          console.log("this.widgetFormPreview_=====>",this.widgetFormPreview_);
          
          this.previewVisible = true;
        });
      }
    },
    showDialogSaveBox() {
      let formId = this.$route.query.id;
      if (!this.widgetForm.column || this.widgetForm.column.length == 0)
        this.$message.error("保存内容不能为空");
      else {
        if (formId) {
          this.handleSave(); //修改
        } else {
          this.dialogFormVisible = true; //新增
        }
      }
    },

    isFieidEmpty(arr){
              let notValid = false;
                // let dbFieldNameTest = /^[a-zA-Z][a-zA-Z0-9_]*$/;
                arr.forEach((e,i)=>{
                  if(!e.fieldId){
                    notValid = true;
                  }
                });
                return notValid;
    },
        // 验证重复元素，有重复返回true；否则返回false
            isRepeat(arr){
            var hash = {};
            for(var i in arr) {
                if(hash[arr[i].fieldId]) {
            // return true;
                return true;
                }
                // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
                hash[arr[i].fieldId] = true;
            }
            // return false;
                return false;
            },
        // 验证重复元素，有重复返回true；否则返回false
            isValidProp(arr){
              let notValid = false;
                let dbFieldNameTest = /^[a-zA-Z][a-zA-Z0-9_]*$/;
                arr.forEach((e,i)=>{
                  if(!dbFieldNameTest.test(e.prop)){
                    notValid = true;
                  }
                });
                return notValid;
                // var hash = {};
                // for(var i in arr) {
                //     if(hash[arr[i].prop]) {
                //     // return true;
                //     return true;
                //     }
                //     // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
                //     hash[arr[i].prop] = true;
                // }
                // // return false;
                // return false;
            },
    isUploadUrl(arr){
              let notValid = false;
                // let dbFieldNameTest = /^[a-zA-Z][a-zA-Z0-9_]*$/;
                arr.forEach((e,i)=>{
                  if(e.type==="upload"&&!e.action){
                    notValid = true;
                  }
                });
                return notValid;
    },
    
    isOverMaxlength(arr){
              let notValid = false;
                // let dbFieldNameTest = /^[a-zA-Z][a-zA-Z0-9_]*$/;
                arr.forEach((e,i)=>{
                  if(e.value&&e.maxlength){
                    if(e.value.length>e.maxlength){
                      notValid = true;
                    }
                  }
                });
                return notValid;
    },
    // 保存 - 设计模板
    handleSave() {
      // if (!this.widgetForm.column || this.widgetForm.column.length == 0) this.$message.error("保存内容不能为空")
      // else {
        if(document
            .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(2) > div > div:nth-child(2) > input')){
              document
            .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(2) > div > div:nth-child(2) > input')
            .style.border = '';
        }
        if(document
      .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(3) > div > div > input')
      ){
        document
      .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(3) > div > div > input')
      .style.border = '';
        }
      if(document
      .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(6) > div:nth-child(1) > div > div > input')
      ){
        document
      .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(6) > div:nth-child(1) > div > div > input')
      .style.border = '';
      }
      if(document
          .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(6) > div:nth-child(2) > div > div > input')
          ){
            document
          .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(6) > div:nth-child(2) > div > div > input')
          .style.border = '';
      }

      let self = this;

      let type = this.$route.query.type;
      let deptId = this.$route.query.deptId;
      let tableid = this.$route.query.tableid;
      let formId = this.$route.query.id;
          let projectId = this.$route.query.projectId;
      this.transformToAvueOptions(this.widgetForm).then((data) => {
        this.widgetFormPreview = data;
        console.log(this.widgetFormPreview);
        console.log(this.$route.query.id);
        let formId = this.$route.query.id;
        
        if(this.isFieidEmpty(data.column)){
          document
          .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(2) > div > div:nth-child(2) > input')
          .style.border = '1px solid red';
          this.$message.error("表单项绑定数据表字段为空！");
          return;
        }
        if(this.isRepeat(data.column)){
          this.$message.error("表单项绑定数据表字段有重复！");
          return;
        }
        if(this.isValidProp(data.column)){
          document
          .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(3) > div > div > input')
          .style.border = '1px solid red';
          this.$message.error("表单项属性值格式不正确！请以字母开头并且只能包含字母数字。");
          return;
        }
        if(this.isUploadUrl(data.column)){
          document
          .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(6) > div:nth-child(1) > div > div > input')
          .style.border = '1px solid red';
          this.$message.error("上传组件未填写action!");
          return;
        }
        if(this.isOverMaxlength(data.column)){
          document
          .querySelector('div[id*="el-collapse-content"] > div > div:nth-child(6) > div:nth-child(2) > div > div > input')
          .style.border = '1px solid red';
          this.$message.error("默认值长度超过最大值!");
          return;
        }
        if (formId) {
          // updateForm({ detail: JSON.stringify(data), id: formId }).then(
          //   (res) => {
          //     console.log(res);
          //     this.$message.success("保存成功!");
          //   }
          // );
          let formCode = this.$route.query.formCode;
          let formName = this.$route.query.formName;
          saveBindForm(type,{
            projectId:projectId,
            deptId:deptId,
            pageUrl:this.pageUrl_,
            // detail: JSON.stringify(data),
            fields:data.column,
            formCode: formCode,
            formName: formName,
            comment:'',
            tableId:tableid,
            formId:formId
          }).then((res) => {
            console.log(res);
            this.dialogFormVisible = false;
            this.$message.success("保存成功!");
            this.handleClose();
          });
        } else {
          saveBindForm(type,{
            projectId:projectId,
            deptId:deptId,
            pageUrl:this.pageUrl_,
            // detail: JSON.stringify(data),
            fields:data.column,
            formCode: self.formInfo.formCode,
            formName: self.formInfo.formName,
            comment:'',
            tableId:tableid
          }).then((res) => {
            console.log(res);
            this.dialogFormVisible = false;
            this.$message.success("保存成功!");
            this.handleClose();
          });
        }
        // this.previewVisible = true
      });
      // }
    },
    // 导入JSON - 弹窗 - 确定
    handleImportJsonSubmit() {
      try {
        this.transAvueOptionsToFormDesigner(this.importJson).then((res) => {
          this.widgetForm = res;
          this.importJsonVisible = false;
          this.handleHistoryChange(this.widgetForm);
        });
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    // 生成JSON - 弹窗
    handleGenerateJson() {
      console.log(this.widgetForm);
      this.transformToAvueOptions(this.widgetForm).then((data) => {
        this.widgetFormPreview = data;
        this.generateJsonVisible = true;
      });
    },
    // 生成JSON - 弹窗 - 确定
    handleGenerate() {
      this.transformToAvueOptions(this.widgetForm).then((data) => {
        this.$emit("submit", data);
      });
    },
    // 生成JSON - 弹窗 - 拷贝
    handleCopy() {
      this.transformToAvueOptions(this.widgetForm).then((data) => {
        let text;
        if (this.beautifierOptions.enabled)
          text = beautifier(data, this.beautifierOptions);
        else text = stringify(data);

        this.$Clipboard({
          text,
        })
          .then(() => {
            this.$message.success("复制成功");
          })
          .catch(() => {
            this.$message.error("复制失败");
          });
      });
    },
    // 预览 - 弹窗 - 确定
    handlePreviewSubmit(form, done) {
      this.$message.success('提交成功');
      done();
      return;
      if (done) {
        this.$alert(this.widgetModels)
          .then(() => {
            done();
          })
          .catch(() => {});
      } else {
        this.$refs.form.validate((valid, done) => {
          if (valid)
            this.$alert(this.widgetModels)
              .then(() => {
                done();
              })
              .catch(() => {});
        });
      }
    },
    // 预览 - 弹窗 - 关闭前
    handleBeforeClose() {
      this.$refs.form.resetForm();
      this.$nextTick(() => (this.previewVisible = false));
    },
    getTypeName(type){
      if(type==2){
        return 'extend';
      }else{
        return 'public';
      }
    },
    handleClose() {
      let type = this.$route.query.type;
      let deptId = this.$route.query.deptId;
      let tableid = this.$route.query.tableid;
      let projectId = this.$route.query.projectId;
      console.log("8888");
      if (
        document.querySelector(
          'div[id*="tab-/form-generator/form-generator"]>span[class="el-icon-close"]'
        )
      ) {
        this.$router.push({
          path: `/form-design/form-design-list?tableid=${tableid}&type=${this.getTypeName(type)}&deptId=${deptId}&projectId=${projectId}&pageUrl=${this.pageUrl_}`,
          // &redirect_url=${encodeURI(location.hash.substring(1))}
        });
        document
          .querySelector(
            'div[id*="tab-/form-generator/form-generator"]>span[class="el-icon-close"]'
          )
          .click();
      }
    },
    // 清空
    handleClear() {
      if (
        this.widgetForm &&
        this.widgetForm.column &&
        this.widgetForm.column.length > 0
      ) {
        this.$confirm("确定要清空吗？", "警告", {
          type: "warning",
        })
          .then(() => {
            this.$set(this.widgetForm, "column", []);
            this.$set(this, "widgetModels", {});
            this.$set(this, "widgetFormSelect", {});
            this.handleHistoryChange(this.widgetForm);
          })
          .catch(() => {});
      } else this.$message.error("没有需要清空的内容");
    },
    // 表单设计器配置项 转化为 Avue配置项
    transformToAvueOptions(obj) {
      console.log("options==>", obj);
      return new Promise((resolve, reject) => {
        try {
          const data = this.deepClone(obj);
          for (let i = 0; i < data.column.length; i++) {
            const col = data.column[i];
            if (
              col.type == "dynamic" &&
              col.children &&
              col.children.column &&
              col.children.column.length > 0
            ) {
              const c = col.children.column;
              c.forEach((item) => {
                delete item.subfield;
              });
              this.transformToAvueOptions(col.children).then((res) => {
                col.children = res;
              });
            } else if (col.type == "group") {
              if (!data.group) data.group = [];

              const group = {
                label: col.label,
                icon: col.icon,
                prop: col.prop,
                arrow: col.arrow,
                collapse: col.collapse,
                display: col.display,
              };
              this.transformToAvueOptions(col.children).then((res) => {
                group.column = res.column;
                data.group.push(group);
              });
              data.column.splice(i, 1);
              i--;
            } else if (
              ["checkbox", "radio", "tree", "cascader", "select"].includes(
                col.type
              )
            ) {
              if (col.dicOption == "static") {
                delete col.dicUrl;
                delete col.dicMethod;
                delete col.dicQuery;
              } else if (col.dicOption == "remote") {
                delete col.dicData;
                if (col.dicQuery && col.dicQuery.length > 0) {
                  const query = {};
                  col.dicQuery.forEach((q) => {
                    if (q.key && q.value) query[q.key] = q.value;
                  });
                  col.dicQuery = query;
                } else delete col.dicQuery;
              }
              delete col.dicOption;
            } else if (["upload"].includes(col.type)) {
              if (col.headersConfig && col.headersConfig.length > 0) {
                const headers = {};
                col.headersConfig.forEach((h) => {
                  if (h.key && h.value) headers[h.key] = h.value;
                });
                col.headers = headers;
              } else delete col.headers;
              delete col.headersConfig;

              if (col.dataConfig && col.dataConfig.length > 0) {
                const data = {};
                col.dataConfig.forEach((h) => {
                  if (h.key && h.value) data[h.key] = h.value;
                });
                col.data = data;
              } else delete col.data;
              delete col.dataConfig;
            }
            if (col.change) col.change = eval(col.change);
            else delete col.change;

            if (col.click) col.click = eval(col.click);
            else delete col.click;

            if (col.focus) col.focus = eval(col.focus);
            else delete col.focus;

            if (col.blur) col.blur = eval(col.blur);
            else delete col.blur;
          }
          resolve(data);
        } catch (e) {
          reject(e);
        }
      });
    },
    // Avue配置项 转化为 表单设计器配置项
    transAvueOptionsToFormDesigner(obj) {
      const data = this.deepClone(obj);
      return new Promise((resolve, reject) => {
        try {
          if (data.column && data.column.length > 0) {
            data.column.forEach((col) => {
              if (
                col.type == "dynamic" &&
                col.children &&
                col.children.column &&
                col.children.column.length > 0
              ) {
                const c = col.children.column;
                c.forEach((item) => {
                  item.subfield = true;
                });
                this.transAvueOptionsToFormDesigner(col.children).then(
                  (res) => {
                    col.children = res;
                  }
                );
              } else if (
                ["checkbox", "radio", "tree", "cascader", "select"].includes(
                  col.type
                )
              ) {
                if (
                  !col.dicData &&
                  col.dicQuery &&
                  typeof col.dicQuery == "object"
                ) {
                  const arr = [];
                  for (let key in col.dicQuery) {
                    arr.push({
                      key,
                      value: col.dicQuery[key],
                      $cellEdit: true,
                    });
                  }
                  col.dicQuery = arr;
                }
                if (col.dicUrl) col.dicOption = "remote";
                else col.dicOption = "static";
                if (!col.dicData) col.dicData = [];
              } else if (["upload"].includes(col.type)) {
                if (col.headers && typeof col.headers == "object") {
                  const arr = [];
                  for (let key in col.headers) {
                    arr.push({
                      key,
                      value: col.headers[key],
                      $cellEdit: true,
                    });
                  }
                  col.headersConfig = arr;
                } else col.headersConfig = [];

                if (col.data && typeof col.data == "object") {
                  const arr = [];
                  for (let key in col.data) {
                    arr.push({
                      key,
                      value: col.data[key],
                      $cellEdit: true,
                    });
                  }
                  col.dataConfig = arr;
                } else col.dataConfig = [];
              }
            });
          }
          if (data.group && data.group.length > 0) {
            for (let i = 0; i < data.group.length; i++) {
              if (!data.column) data.column = [];
              const col = data.group[i];

              const group = {
                type: "group",
                label: col.label,
                icon: col.icon,
                prop: col.prop,
                arrow: col.arrow,
                collapse: col.collapse,
                display: col.display,
              };
              this.transAvueOptionsToFormDesigner(col).then((res) => {
                group.children = res;
                data.column.push(group);
              });
            }
            delete data.group;
          }
          resolve(data);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles/index.scss";
.el-aside {
  overflow: scroll;
}
.avue-main {
  overflow: scroll;
}
</style>
